<template>
    <div id="tst">
      <v-tooltip style="z-index: 929;" bottom>
        <v-btn slot="activator" dark icon small flat @click.native="rmvColaborador()">
          <v-icon class="material-icons">delete_outline</v-icon>
        </v-btn>
          <span>Remover colaborador</span>
      </v-tooltip>
    </div>

</template>
<script>
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
export default {
  props: ["conta", "empresa", "alert", "nota", "table"],
  components: {},

  data: () => ({}),
  mounted: function() {
    this.$nextTick(function() {});
  },
  updated: function() {},
  watch: {},
  computed: {},
  methods: {
    rmvColaborador: function() {
      this.service = new UsuarioService(this.$http);
      this.service.removerDaConta(this.conta.conta,this.nota.item._id,this.empresa._id).then( res=>{this.$emit("attTableEmp", res);})
    },
  }
};
</script>
<style>
#tst {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/rmvColaborador/RmvColaborador.vue